import { NgModule } from '@angular/core';
import { EditPageComponent } from '../../../components/edits/edit-page/edit-page.component';
import { EditRowComponent } from '../../../components/edits/edit-row/edit-row.component';
import { EditSidenavComponent } from '../../../components/edits/edit-sidenav/edit-sidenav.component';
import { EditCShowcaseComponent } from '../../../components/edits/edit-c-showcase/edit-c-showcase.component';
import { EditCTopicComponent } from '../../../components/edits/edit-c-topic/edit-c-topic.component';
import { EditCFeedbackComponent } from '../../../components/edits/edit-c-feedback/edit-c-feedback.component';
import { EditCCtaComponent } from '../../../components/edits/edit-c-cta/edit-c-cta.component';
import { EditCImageComponent } from '../../../components/edits/edit-c-image/edit-c-image.component';
import { EditCTextComponent } from '../../../components/edits/edit-c-text/edit-c-text.component';
import { EditCEmbedComponent } from '../../../components/edits/edit-c-embed/edit-c-embed.component';
import { ColorPickerComponent, ColorPickerDirective } from 'ngx-color-picker';
import { ReorderContextMenuModule } from '../../../components/reorder-context-menu/reorder-context-menu.module';
import { ColorComponent } from '../../../components/ui/color/color.component';
import { AdvancedSharedModule } from './../advanced-shared/advanced-shared.module';
import { MediumEditorSharedComponent } from '../../../components/edits/edit-sidenav/medium-editor-shared/medium-editor-shared.component';
import { EditCustomerCareComponent } from '../../../components/edits/edit-customer-care/edit-customer-care.component';
import { SharedModule } from '../../../shared/shared.module';
import { SideNavFullRecordComponent } from '../../../components/edits/edit-sidenav/side-nav-full-record/side-nav-full-record.component';

@NgModule({
  imports: [
    AdvancedSharedModule,
    SharedModule,
    ColorPickerComponent,
    ColorPickerDirective,
    ReorderContextMenuModule,
  ],
  declarations: [
    EditPageComponent,
    EditRowComponent,
    EditSidenavComponent,
    EditCShowcaseComponent,
    EditCTopicComponent,
    EditCFeedbackComponent,
    EditCCtaComponent,
    EditCImageComponent,
    EditCTextComponent,
    EditCEmbedComponent,
    EditCustomerCareComponent,
    ColorComponent,
    MediumEditorSharedComponent,
    SideNavFullRecordComponent,
  ],
  exports: [
    SideNavFullRecordComponent,
    EditPageComponent,
    EditRowComponent,
    EditSidenavComponent,
    EditCShowcaseComponent,
    EditCTopicComponent,
    EditCFeedbackComponent,
    EditCCtaComponent,
    EditCImageComponent,
    EditCTextComponent,
    EditCEmbedComponent,
    EditCustomerCareComponent,
    ColorComponent,
    MediumEditorSharedComponent,
  ],
})
export class EditCSharedModule {}
